import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=56074db0&"
import script from "./TasksTable.vue?vue&type=script&lang=ts&"
export * from "./TasksTable.vue?vue&type=script&lang=ts&"
import style0 from "./TasksTable.vue?vue&type=style&index=0&id=56074db0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports